import {
  CardMedia,
  Box,
  IconButton,
  Typography,
  CircularProgress,
  Skeleton,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { uploadUserFile } from "@/services/upload";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentUser } from "@/services/hooks";
import { useState, useEffect } from "react";
import Crop from "@/components/Crop";
import AlertSnackbar from "@/components/AlertSnackbar";
export default function ArtworkImage() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const [editing, setEditing] = useState(false);
  const [file, setFile] = useState(null);
  const queryClient = useQueryClient();
  const metaKey = "artwork";
  const [showSnackbar, setShowSnackbar] = useState(false);
  const imgUrl = file
    ? URL.createObjectURL(file)
    : currentUser?.meta?.[metaKey];

  const mutation = useMutation({
    mutationFn: (blob) => uploadUserFile(blob, metaKey),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const handleFileChange = () => {
    const selectedFile = document.getElementById(metaKey).files[0];
    setFile(selectedFile);
    setEditing(true);
  };

  const onDone = (blob) => {
    mutation.mutate(blob);
    setFile(blob);
    setEditing(false);
  };

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={200}
        width={200}
        sx={{ borderRadius: "25px", ml: 2 }}
      />
    );
  }

  if (editing) {
    return (
      <Crop
        file={file}
        setFile={setFile}
        setEditing={setEditing}
        onDone={onDone}
      />
    );
  }

  return (
    <Box sx={{ width: "200px", ml: 2 }}>
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />
      <Box sx={{ position: "relative" }}>
        <CardMedia
          component="img"
          src={imgUrl}
          sx={{
            borderRadius: "10px",
            aspectRatio: "1/1",
            opacity: mutation.isPending ? 0.5 : 1,
            transition: "opacity 0.2s ease-in-out",
          }}
        />

        <label htmlFor={metaKey}>
          <IconButton
            component="span"
            disabled={mutation.isPending}
            sx={{
              position: "absolute",
              bottom: 10,
              right: 10,
              opacity: 0.8,
              zIndex: 1000,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.7)",
              },
            }}
          >
            {mutation.isPending ? (
              <CircularProgress size={20} color="secondary" />
            ) : (
              <Edit />
            )}
          </IconButton>
        </label>
      </Box>
      <input
        accept="image/*"
        style={{ display: "none" }}
        id={metaKey}
        type="file"
        onChange={handleFileChange}
      />
      <Typography variant="caption" color="text.secondary" sx={{ my: 2 }}>
        Default Song Artwork
      </Typography>
    </Box>
  );
}
